import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation files using the new modular approach
import translations from '../locales'
// Import specific files for namespaces
import servicesEn from '../locales/en/services.json'
import servicesAr from '../locales/ar/services.json'
import sdgEn from '../locales/en/sdg.json'
import sdgAr from '../locales/ar/sdg.json'
import commonEn from '../locales/en/common.json'
import commonAr from '../locales/ar/common.json'
import filtersEn from '../locales/en/filters.json'
import filtersAr from '../locales/ar/filters.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: translations.en,
        common: commonEn,
        services: servicesEn,
        sdg: sdgEn,
        filters: filtersEn,
        homepage: translations.en.homepage,
        contact: translations.en.contact,
        cart: translations.en.cart,
        equipment: translations.en.equipment,
        about: translations.en.about,
        hero: translations.en.hero,
        inquiry: translations.en.inquiry,
        auth: translations.en.auth,
        dashboard: translations.en.dashboard
      },
      ar: {
        translation: translations.ar,
        common: commonAr,
        sdg: sdgAr,
        services: servicesAr,
        filters: filtersAr,
        homepage: translations.ar.homepage,
        contact: translations.ar.contact,
        cart: translations.ar.cart,
        equipment: translations.ar.equipment,
        about: translations.ar.about,
        hero: translations.ar.hero,
        inquiry: translations.ar.inquiry,
        auth: translations.ar.auth,
        dashboard: translations.ar.dashboard
      }
    },
    lng: 'en', // default language
    fallbackLng: 'en',
    defaultNS: 'translation',
    ns: ['translation', 'common', 'services', 'filters', 'homepage', 'contact', 'cart', 'equipment', 'about', 'hero', 'inquiry', 'auth', 'dashboard'],
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false // React already escapes values
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  })

export default i18n
